import { useMutation } from '@tanstack/react-query';
import { AutoComplete, Col, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import {
  GET_ALL_CITY,
  GET_ALL_DISTRICT,
  GET_ALL_WARD,
} from 'apis/GraphQL/Queries/cityQuery';
import {
  GET_ALL_CUSTOMER,
  GET_CUSTOMER_RANK_COMBO_BOX,
  GET_STATUS_VIP,
  GET_REGION,
} from 'apis/GraphQL/Queries/customerQuery';
import {
  VARIABLES_STATUS_CUSTOMER,
  VARIABLE_GET_ALL_CUSTOMER_RANK,
} from 'apis/GraphQL/Variables/customer';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import { FormFilter, SelectForm } from 'components';
import { useUser } from 'contexts/UserProvider';
import { IParamQraphQL } from 'interfaces/GraphQL/GraphQL';
import Content from 'layouts/Content';
import { KeyboardEvent, useEffect, useState } from 'react';

const spanCol = 8;

interface Iprops {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  setFormParams: (params: any) => void;
}

const FilterCustomerPage = ({ isOpen, setFormParams }: Iprops) => {
  const [form] = useForm();
  const { user } = useUser();
  const [optionsVipProcess, setOptionsVipProcess] = useState<any>([]);
  const [optionsVipProduct, setOptionsVipProduct] = useState<any>([]);
  const [optionsWard, setOptionsWard] = useState<any>([]);
  const [optionsWardNew, setOptionsWardNew] = useState<any>([]);
  const [optionsDistrict, setOptionsDistrict] = useState<any>([]);
  const [optionsCity, setOptionsCity] = useState<any>([]);
  const [optionsCityNew, setOptionsCityNew] = useState<any>([]);
  const [regionItems, setRegionItems] = useState<any>([]);
  const [optionsStatus, setOptionsStatus] = useState<any>([]);

  // useEffect(() => {
  //   form.setFieldValue('id', 'KH202410000041');
  // });

  const [dataFiltermainCustomerId, setDataFiltermainCustomerId] = useState<any>(
    [],
  );
  const [dataFilterSapCustomerId, setDataFilterSapCustomerId] = useState<any>(
    [],
  );

  const [dataFilterId, setDataFilterId] = useState<any>([]);
  const [dataFilterStoreName, setDataFilterStoreName] = useState<any>([]);
  const [dataFilterCccd, setDataFilterCccd] = useState<any>([]);
  const [dataFilterPhone, setDataFilterPhone] = useState<any>([]);
  const [dataFilterTaxId, setDataFilterTaxId] = useState<any>([]);

  const { mutate: getAllCusFiltermainCustomerId } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            // ...(user?.plantCode &&
            //   !(user?.isAdmin || user?.isHO) && {
            //     plantId: { equals: user.plantCode },
            //   }),
            AND: [
              {
                mainCustomerId: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(
          res.data.getCustomer.items.map((item: any) => item.mainCustomerId),
        ),
      ).map((mainCustomerId) => {
        return res.data.getCustomer.items.find(
          (item: any) => item.mainCustomerId === mainCustomerId,
        );
      });
      setDataFiltermainCustomerId(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutate: getAllCusFilterSapCustomerId } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            ...(user?.plantCode &&
              !(user?.isAdmin || user?.isHO) && {
                plantId: { equals: user.plantCode },
              }),
            AND: [
              {
                sapCustomerId: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(
          res.data.getCustomer.items.map((item: any) => item.sapCustomerId),
        ),
      ).map((sapCustomerId) => {
        return res.data.getCustomer.items.find(
          (item: any) => item.sapCustomerId === sapCustomerId,
        );
      });
      setDataFilterSapCustomerId(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutate: getAllCusFilterId } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            ...(user?.plantCode &&
              !(user?.isAdmin || user?.isHO) && {
                plantId: { equals: user.plantCode },
              }),
            AND: [
              {
                id: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(res.data.getCustomer.items.map((item: any) => item.id)),
      ).map((id) => {
        return res.data.getCustomer.items.find((item: any) => item.id === id);
      });
      setDataFilterId(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutate: getAllCusFilterStoreName } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            ...(user?.plantCode &&
              !(user?.isAdmin || user?.isHO) && {
                plantId: { equals: user.plantCode },
              }),
            AND: [
              {
                storeName: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(res.data.getCustomer.items.map((item: any) => item.storeName)),
      ).map((storeName) => {
        return res.data.getCustomer.items.find(
          (item: any) => item.storeName === storeName,
        );
      });
      setDataFilterStoreName(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutate: getAllCusFilterCccd } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            ...(user?.plantCode &&
              !(user?.isAdmin || user?.isHO) && {
                plantId: { equals: user.plantCode },
              }),
            AND: [
              {
                cccd: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(res.data.getCustomer.items.map((item: any) => item.cccd)),
      ).map((cccd) => {
        return res.data.getCustomer.items.find(
          (item: any) => item.cccd === cccd,
        );
      });
      setDataFilterCccd(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutate: getAllCusFilterPhone } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            ...(user?.plantCode &&
              !(user?.isAdmin || user?.isHO) && {
                plantId: { equals: user.plantCode },
              }),
            AND: [
              {
                phone: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(res.data.getCustomer.items.map((item: any) => item.phone)),
      ).map((phone) => {
        return res.data.getCustomer.items.find(
          (item: any) => item.phone === phone,
        );
      });
      setDataFilterPhone(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutate: getAllCusFilterTaxId } = useMutation({
    mutationFn: (data: any) =>
      axiosGraphQL.post('/graphql', {
        query: GET_ALL_CUSTOMER,
        variables: {
          input: {
            ...(user?.plantCode &&
              !(user?.isAdmin || user?.isHO) && {
                plantId: { equals: user.plantCode },
              }),
            AND: [
              {
                taxId: {
                  contains: data.trim(),
                },
              },
            ],
          },
        },
      }),
    onSuccess: (res) => {
      const uniqueData = Array.from(
        new Set(res.data.getCustomer.items.map((item: any) => item.taxId)),
      ).map((taxId) => {
        return res.data.getCustomer.items.find(
          (item: any) => item.taxId === taxId,
        );
      });
      setDataFilterTaxId(uniqueData.slice(0, 10));
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const mutationStatus = useMutation({
    mutationKey: ['getAllStatus'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsStatus(
        res.data?.getCode
          ? res.data?.getCode.items.map((item: any) => ({
              label: item.name,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const mutationStatusVip = useMutation({
    mutationKey: ['getAllStatusVip'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res, variables) => {
      const options = res.data?.getCode
        ? res.data?.getCode.items.map((item: any) => ({
            label: item.name,
            value: item.id,
          }))
        : [];

      // if (variables.type === 'process') setOptionsVipProcess(options);
      // if (variables.type === 'product') setOptionsVipProduct(options);
      setOptionsVipProduct(options);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const mutationWard = useMutation({
    mutationKey: ['getAllWard'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsWard(
        res.data?.getWard
          ? res.data?.getWard.items.map((item: any) => ({
              label: item.name,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const mutationDistrict = useMutation({
    mutationKey: ['getAllDistrict'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsDistrict(
        res.data?.getDistrict
          ? res.data?.getDistrict.items.map((item: any) => ({
              label: item.name,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const mutationCity = useMutation({
    mutationKey: ['getAllCity'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsCity(
        res.data?.getCity
          ? res.data?.getCity.items.map((item: any) => ({
              label: item.name,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    // mutationStatusVip.mutate({
    //   query: GET_STATUS_VIP,
    //   variables: VARIABLE_GET_STATUS_VIP_PROCESS,
    //   type: 'process',
    // });
    // mutationStatusVip.mutate({
    //   query: GET_STATUS_VIP,
    //   variables: VARIABLE_GET_STATUS_VIP_PRODUCT,
    //   type: 'product',
    // });
    mutationStatusVip.mutate({
      query: GET_CUSTOMER_RANK_COMBO_BOX,
      variables: VARIABLE_GET_ALL_CUSTOMER_RANK,
    });
    mutationCity.mutate({
      query: GET_ALL_CITY,
    });
    mutationRegion.mutate({
      query: GET_REGION,
      variables: {
        take: 5000,
      },
    });
    mutationStatus.mutate({
      query: GET_STATUS_VIP,
      variables: VARIABLES_STATUS_CUSTOMER,
    });
  }, []);

  const onFinish = (values: any) => {
    const formatedValues = Object.keys(values).reduce(
      (total: any, current: any) => {
        total[current] = values[current]?.trim();
        return total;
      },
      {},
    );

    setFormParams({ ...formatedValues, plantId: undefined });
  };

  const handleChangeCity = (value: any) => {
    form.setFieldsValue({
      districtId: undefined,
      wardId: undefined,
    });

    if (!value) {
      setOptionsWard([]);
      setOptionsDistrict([]);
      return;
    }

    mutationDistrict.mutate({
      query: GET_ALL_DISTRICT,
      variables: {
        input: {
          cityId: {
            equals: value,
          },
        },
      },
    });
  };

  const handleChangeDistrict = (value: any) => {
    form.setFieldsValue({
      wardId: undefined,
    });

    if (!value) {
      setOptionsWard([]);
      return;
    }

    mutationWard.mutate({
      query: GET_ALL_WARD,
      variables: {
        input: {
          districtId: {
            equals: value,
          },
        },
      },
    });
  };

  const mutationRegion = useMutation({
    mutationKey: ['getRegion'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      const items = res.data?.getRegion?.items || [];
      setRegionItems(items);

      const citiesMap: { [key: string]: string } = {};
      items.forEach((item: any) => {
        const cityName = item.cityName || item.tcity?.name;
        if (item.cityId && cityName) {
          citiesMap[item.cityId] = cityName;
        }
      });
      const cityOptions = Object.keys(citiesMap).map((id) => ({
        label: citiesMap[id],
        value: id,
      }));
      setOptionsCityNew(cityOptions);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleChangeCityNew = (value: any) => {
    form.setFieldsValue({
      wardNewId: undefined,
    });

    if (!value) {
      setOptionsWardNew([]);
      return;
    }

    const filteredWards = regionItems
      .filter((item: any) => item.cityId === value)
      .map((item: any) => ({
        label: item.wardName || item.tward?.name,
        value: item.wardId,
      }));
    setOptionsWardNew(filteredWards);
  };

  const onCancel = () => {
    setDataFiltermainCustomerId([]);
    setDataFilterSapCustomerId([]);
    setDataFilterId([]);
    setDataFilterStoreName([]);
    setDataFilterCccd([]);
    setDataFilterPhone([]);
    setDataFilterTaxId([]);
    setOptionsDistrict([]);
    setOptionsWard([]);
    setOptionsWardNew([]);

    form.resetFields();
    setFormParams({});

    // setOpen(false);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onFinish(form.getFieldsValue());
      e.preventDefault();
    }
  };

  return (
    <Content isOpen={isOpen}>
      <FormFilter onFinish={onFinish} onCancel={onCancel} form={form}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã khách hàng" name="sapCustomerId">
              {/* <InputForm
                onKeyDown={handleKeyDown}
                placeholder="Nhập mã Khách hàng"
              /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFilterSapCustomerId.map((item: any) => ({
                  value: item.sapCustomerId,
                  label: item.sapCustomerId,
                  key: item.id,
                }))}
                // onSearch={getAllCusFilterSapCustomerId}
                onSelect={(value) => {
                  // getAllCusFilterSapCustomerId(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập mã Khách hàng"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã DMS" name="id">
              {/* <InputForm onKeyDown={handleKeyDown} placeholder="Nhập mã DMS" /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFilterId.map((item: any) => ({
                  value: item.id,
                  label: item.id,
                  key: item.id,
                }))}
                // onSearch={getAllCusFilterId}
                onSelect={(value) => {
                  // getAllCusFilterId(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập mã DMS"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã cha" name="mainCustomer">
              {/* <InputForm onKeyDown={handleKeyDown} placeholder="Nhập mã cha" /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFiltermainCustomerId.map((item: any) => ({
                  value: item.mainCustomerId,
                  label: item.mainCustomerId,
                  key: item.id,
                }))}
                onSearch={getAllCusFiltermainCustomerId}
                onSelect={(value) => {
                  // getAllCusFiltermainCustomerId(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập mã cha"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Tên khách hàng" name="storeName">
              {/* <InputForm
                onKeyDown={handleKeyDown}
                placeholder="Nhập tên Khách hàng"
              /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFilterStoreName.map((item: any) => ({
                  value: item.storeName,
                  label: item.storeName,
                  key: item.id,
                }))}
                // onSearch={getAllCusFilterStoreName}
                onSelect={(value) => {
                  // getAllCusFilterStoreName(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập tên Khách hàng"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã số thuế" name="taxId">
              {/* <InputForm
                onKeyDown={handleKeyDown}
                placeholder="Nhập mã số thuế"
              /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFilterTaxId.map((item: any) => ({
                  value: item.taxId,
                  label: item.taxId,
                  key: item.id,
                }))}
                // onSearch={getAllCusFilterTaxId}
                onSelect={(value) => {
                  // getAllCusFilterTaxId(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập mã số thuế"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="CCCD" name="cccd">
              {/* <InputForm onKeyDown={handleKeyDown} placeholder="Nhập CCCD" /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFilterCccd.map((item: any) => ({
                  value: item.cccd,
                  label: item.cccd,
                  key: item.id,
                }))}
                // onSearch={getAllCusFilterCccd}
                onSelect={(value) => {
                  // getAllCusFilterCccd(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập CCCD"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Số điện thoại" name="phone">
              {/* <InputForm
                onKeyDown={handleKeyDown}
                placeholder="Nhập số điện thoại"
              /> */}
              <AutoComplete
                allowClear
                size="large"
                className={` w-full rounded-xl`}
                options={dataFilterPhone.map((item: any) => ({
                  value: item.phone,
                  label: item.phone,
                  key: item.id,
                }))}
                // onSearch={getAllCusFilterPhone}
                onSelect={(value) => {
                  // getAllCusFilterPhone(value);
                  onFinish(form.getFieldsValue());
                }}
                placeholder="Nhập số điện thoại"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Hạng thẻ" name="trank">
              <SelectForm
                placeholder="Chọn hạng thẻ"
                options={optionsVipProduct}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Trạng thái" name="status">
              <SelectForm
                placeholder="Chọn trạng thái"
                options={optionsStatus}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Tỉnh/Thành phố" name="cityId">
              <SelectForm
                placeholder="Chọn tỉnh/Thành phố"
                options={optionsCity}
                onChange={handleChangeCity}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Quận/Huyện" name="districtId">
              <SelectForm
                placeholder="Chọn quận/Huyện"
                options={optionsDistrict}
                onChange={handleChangeDistrict}
              />
            </Form.Item>
          </Col>
          {/* <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Doanh thu" name="">
              <SelectForm
                placeholder="Chọn doanh thu"
                // options={optionsStatus}
              />
              <InputForm
                placeholder="Nhập doanh thu"
              />
            </Form.Item>
          </Col> */}
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Phường/Xã" name="wardId">
              <SelectForm placeholder="Chọn phường/Xã" options={optionsWard} />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Tỉnh/Thành phố mới" name="cityNewId">
              <SelectForm
                placeholder="Chọn tỉnh/Thành phố mới"
                options={optionsCityNew}
                onChange={handleChangeCityNew}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Phường/Xã mới" name="wardNewId">
              <SelectForm
                placeholder="Chọn phường/Xã mới"
                options={optionsWardNew}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterCustomerPage;
